import styled from './listaprodutos.module.css';
import Pagination from 'react-paginate';
import '../../utils/pagination.css';
import { useEffect, useState } from 'react';
import api from '../../services/api';
import { AuthContext } from '../../services/global';
import { LoaderProd } from '../Loader';
import { Alerta } from '../../utils/functions';
import { useSearchParams } from 'react-router-dom';

function ListaProduto() {
    const login = JSON.parse(localStorage.getItem("login"));
    const cgccli = login.cgccli;
    const [CurrentPage, setCurrentPage] = useState(0);
    const [isLoading, setLoading] = useState(false);
    const [qtd, setqtd] = useState(0);

    const [produtos, setprodutos] = useState([]);
    const itemPerPage = 9;
    //Logica para Paginação
    const pages = (Math.ceil(produtos.length / itemPerPage));
    const startIndex = CurrentPage * itemPerPage;
    const endtIndex = startIndex + itemPerPage;

    const currentItens = (produtos.slice(startIndex, endtIndex));


    function GetProdutos() {
        setLoading(true);
        api.get(`produtos/?cgccli=${cgccli}`)
            .then((response) => {
                if (!response.data.msg) {
                    setprodutos(response.data);
                    setCurrentPage(0);

                    setLoading(false);
                } else {
                    setLoading(false);
                    Alerta('Erro!', response.data.msg, 'error');
                }
            })
    }

    const PageClick = (event) => {
        setCurrentPage(event.selected);
    };

    useEffect(() => {
        GetProdutos();
    }, [])

    return (
        <div className={styled.container}>
            <div className={styled.content}>
                {isLoading == true ? <LoaderProd /> : <>
                    {currentItens.map((prod) => {
                        return (
                            <div className={styled.card}>
                                <div className={styled.contentcard}>
                                    <img src={prod.img} alt="" className={styled.image}></img>
                                    <div className={styled.dados}>
                                        <a>{prod.codpro} - {prod.nompro}</a>
                                        {/*<span>{prod.valvis.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</span>*/}
                                    </div>
                                    <div className={styled.divqtd}>
                                        {/*<input type='text' placeholder='0'></input>*/}
                                        <button>Adicionar</button>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                    }
                </>
                }


            </div>
            < div className={styled.paginate}>
                <Pagination
                    breakLabel="..."
                    nextLabel=">>"
                    onPageChange={PageClick}
                    pageCount={pages}
                    previousLabel="<<"
                    renderOnZeroPageCount={null}
                    containerClassName={'pagination'}
                    pageClassName={'page-item'}
                    pageLinkClassName={'page-link'}
                    previousClassName={'page-item'}
                    previousLinkClassName={'page-link'}
                    nextClassName={'page-item'}
                    nextLinkClassName={'page-link'}
                    breakClassName={'page-item'}
                    breakLinkClassName={'page-link'}
                    activeClassName={'active'}
                    forcePage={CurrentPage}
                />
            </div>
        </div>
    )
}

export default ListaProduto;